<template lang="pug">
#bloco-tabela-relatorio-rastreabilidade-gestao
    .tabela-relatorios-inseridos-listagem

    el-table(
        :key="listagemTableKey('relatorio-gestao', relatorios, paginacao.pagina + 1)",
        :data='relatorios',
        v-loading='carregando',
        style='width: 100%',
        @sort-change='sortChangeRequest'
    )
        el-table-column(
            prop='numeroContrato',
            :label='$t("mensagens.relatorioRastreabilidade.comuns.numeroContrato")',
            sortable='custom'
        )

        el-table-column(
            prop='volumeContrato',
            :label='$t("mensagens.relatorioRastreabilidade.listagem.volume")',
            sortable='custom'
        )

        el-table-column(
            prop='culturaCodigo',
            :label='$t("mensagens.relatorioRastreabilidade.comuns.cultura")',
            sortable='custom'
        )

        el-table-column.elegivel(
            prop='statusTraduzido',
            :label='$t("mensagens.relatorioRastreabilidade.listagem.status")',
            sortable='custom'
        )

        el-table-column.elegivel(
            prop='dataAnalise',
            :label='$t("mensagens.relatorioRastreabilidade.listagem.dataEnvio")',
            width='140',
            sortable='custom'
        )

        el-table-column(
            :label='$t("mensagens.comuns.acoes")',
            align='center',
            width='170'
        )
            .template(slot-scope='scope')
                el-dropdown.action-button(trigger='click')
                    span.el-dropdown-link
                        i.mdi.mdi-dots-vertical
                    el-dropdown-menu(slot='dropdown')
                        el-dropdown-item(
                            v-if='regraPodeVisualizarRelatorio(scope.row.status)',
                            icon='el-icon-view',
                            @click.native='visualizarRelatorio(scope.row.id)'
                        ) {{ $t('mensagens.relatorioRastreabilidade.listagem.visualizarRelatorioRastreabilidade') }}

                        el-dropdown-item(
                            v-if='regraPodeEditarRelatorio(scope.row.status)',
                            icon='mdi mdi-square-edit-outline',
                            @click.native='irParaEditar(scope.row.id)'
                        ) {{ $t('mensagens.comuns.editar') }}

                        el-dropdown-item(
                            icon='el-icon-delete',
                            @click.native='removerContratoRelatorio(scope.row)'
                        ) {{ $t('mensagens.comuns.remover') }}

                        el-dropdown-item(
                            icon='mdi mdi-share-variant-outline',
                            @click.native='compartilharRelatorio(scope.row)'
                        ) {{ $t('mensagens.relatorioRastreabilidade.listagem.compartilharRelatorio') }}
        template(slot='empty')
            el-empty(:description='$t("mensagens.comuns.semDados")')

    .modal-compartilhamento-relatorio
        ModalCompartilhamentoRelatorio(
            ref='modalCompartilhamentoRelatorio',
            :show='mostrarModalCompartilhamentoRelatorio',
            :link='linkApi',
            :relatorioId='relatorioId || 0',
            @enviarEmail='compartilharRelatorioRastreabilidadePorEmail',
            @voltar='mostrarModalCompartilhamentoRelatorio = false'
        )

    .tabela-gestao-relatorio-rastreabilidade__paginacao
        div
            span.pagina {{ paginacao.total + ' ' + getLabelRelatorios() }}

        el-pagination(
            background,
            :page-size='paginacao.itensPorPagina',
            :pager-count='5',
            :current-page.sync='paginacao.pagina + 1',
            layout='prev, pager, next',
            :total='paginacao.total',
            @current-change='atualizarPagina'
        )
</template>

<script>
import ModalCompartilhamentoRelatorio from '@/components/relatorioRastreabilidade/ModalCompartilhamentoRelatorio.vue';
import RelatorioRastreabilidadeService from '@/services/RelatorioRastreabilidadeService';

export default {
    name: 'TabelaGestaoRelatorioRastreabilidade',
    components: {
        ModalCompartilhamentoRelatorio
    },
    props: {
        relatorios: {
            type: Array,
            Required: true
        },
        paginacao: {
            type: Object,
            Required: true
        },
        carregando: {
            type: Boolean,
            Required: true
        }
    },

    data() {
        return {
            mostrarModalCompartilhamentoRelatorio: false,
            linkApi: '',
            relatorioId: null
        };
    },
    methods: {
        atualizarPagina(pagina) {
            this.$emit('mudarPagina', pagina - 1);
        },
        sortChangeRequest(column) {
            let prop = column.prop;
            if (prop === 'culturaCodigo') {
                prop = 'cultura.codigo';
            }

            let params = {
                order: null,
                column: prop
            };

            if (column.order === 'ascending') {
                params.order = 'ASC';
            } else if (column.order === 'descending') {
                params.order = 'DESC';
            }

            this.$emit('handleSort', params);
        },
        irParaEditar(id) {
            this.$router.push({
                name: 'EditarRelatorio',
                params: { idRelatorio: id }
            });
        },
        async removerContratoRelatorio(contratoRelatorio) {
            const result = await this.$messageBox.confirm(
                `${this.$t(
                    'mensagens.relatorioRastreabilidade.listagem.desejaRemoverContrato'
                )} ${contratoRelatorio.numeroContrato}?`,
                this.$t('mensagens.comuns.aviso'),
                {
                    confirmButtonText: this.$t('mensagens.comuns.sim'),
                    cancelButtonText: this.$t('mensagens.comuns.cancelar'),
                    type: 'warning'
                }
            );
            if (result) {
                this.$emit('removerContratoRelatorio', contratoRelatorio.id);
            }
        },
        visualizarRelatorio(relatorioId) {
            this.$router.push({
                name: 'VisualizarRelatorio',
                params: { relatorioId }
            });
        },
        async compartilharRelatorio(row) {
            if (row.status === 'Em preenchimento') {
                const result = await this.$messageBox.confirm(
                    this.$t(
                        'mensagens.relatorioRastreabilidade.listagem.mensagemCompartilhamentoRelatorio'
                    ),
                    this.$t('mensagens.comuns.aviso'),
                    {
                        confirmButtonText: this.$t('mensagens.comuns.sim'),
                        cancelButtonText: this.$t('mensagens.comuns.cancelar'),
                        type: 'warning'
                    }
                );
                if (result) {
                    await this.compartilharRelatorioRastreabilidade(row.id);
                    this.$emit('carregarTabela');
                }
            } else {
                this.compartilharRelatorioRastreabilidade(row.id);
            }
        },
        async compartilharRelatorioRastreabilidade(relatorioId) {
            this.linkApi = '';
            this.relatorioId = null;
            try {
                const { data } =
                    await RelatorioRastreabilidadeService.compartilharRelatorio(
                        relatorioId
                    );
                this.linkApi = data.urlRelatorio;
                this.relatorioId = relatorioId;
                this.mostrarModalCompartilhamentoRelatorio = true;
            } catch (erro) {
                this.$notify.error({
                    message: erro.response.data.message
                });
            }
        },
        async compartilharRelatorioRastreabilidadePorEmail(email) {
            try {
                await RelatorioRastreabilidadeService.compartilharRelatorioEmail(
                    this.relatorioId,
                    email
                );

                this.$notify.success({
                    message: this.$t(
                        'mensagens.relatorioRastreabilidade.listagem.emailEnviadoSucesso'
                    )
                });
                this.$refs.modalCompartilhamentoRelatorio.fecharModal();
            } catch (erro) {
                this.$notify.error({
                    message: erro.response.data.message
                });
            }
        },
        regraPodeVisualizarRelatorio(status) {
            if (status === 'Em preenchimento') {
                return true;
            } else if (status === 'Enviado') {
                return true;
            }

            return false;
        },
        regraPodeEditarRelatorio(status) {
            return status !== 'Enviado';
        },
        getLabelRelatorios() {
            return this.paginacao.total === 1
                ? this.$t(
                      'mensagens.relatorioRastreabilidade.listagem.relatorio'
                  )
                : this.$t(
                      'mensagens.relatorioRastreabilidade.listagem.relatorios'
                  );
        }
    }
};
</script>

<style lang="scss">
#bloco-tabela-relatorio-rastreabilidade-gestao {
    h1,
    .el-checkbox {
        font-weight: bold;
        font-size: 16px;
        margin-bottom: 10px;
        background: transparent;
    }

    .el-table {
        border-top-right-radius: 11px;
        border-top-left-radius: 11px;
        min-height: 240px;
        thead.has-gutter {
            height: 67px;
            th.el-table__cell {
                background-color: #fbfbfb;
            }
        }

        .descricao-item-tabela {
            margin-left: 55px;
            margin-right: 55px;
        }
    }

    .el-table__cell {
        font-size: 12px;
    }
    .is-leaf {
        font-size: 13px;
    }

    .el-table .cell {
        word-break: normal;
    }

    .el-descriptions-item__container .el-descriptions-item__content {
        display: flex;
        flex-direction: column;
        column-count: 3;
    }

    .el-table td {
        padding: 12px 0px;
        vertical-align: top;
        border-top: 1px solid #e9ecef;
    }

    .tabela-gestao-relatorio-rastreabilidade__paginacao {
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: var(--white);
        padding: 14px 11px;
        border-bottom-left-radius: 11px;
        border-bottom-right-radius: 11px;

        .pagina {
            color: var(--primary);
            font-weight: 600;
        }
    }

    span.el-descriptions-item__label.has-colon {
        font-weight: bold;
    }

    .success-font-color {
        color: var(--success);
    }

    .danger-font-color {
        color: var(--danger);
    }

    .el-descriptions-item__label.has-colon::after {
        content: '' !important;
    }

    .tabela-relatorios-inseridos-listagem {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin-bottom: 10px;
    }
}
</style>
